import { provideConfig } from '@spartacus/core'
import { NgModule } from '@angular/core'
import { FsComponentConverter } from 'fs-spartacus-common'
import { HEADER_IMAGE_BACKGROUND_CONVERTER_TOKEN, HeaderImageBackgroundConverter } from './header-image-background.component.converter'

@NgModule({
  providers: [
    provideConfig({
      featureModules: {
        headerImageBackgroundFeature: {
          module: () => import('./header-image-background.module').then((m) => m.HeaderImageBackgroundModule),
          cmsComponents: ['headerimagebackground'],
        },
      }
    }),
    {
      provide: HEADER_IMAGE_BACKGROUND_CONVERTER_TOKEN,
      useExisting: HeaderImageBackgroundConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        headerimagebackground: HEADER_IMAGE_BACKGROUND_CONVERTER_TOKEN
      },
      multi: true
    }
  ]
})
export class HeaderImageBackgroundFeatureModule {}
